import { WEBSITE_URL } from "../configs/website";
import { protectUserAgent, handleUserAgentError } from "./userAgentProtection";

// Initialize userAgent protection
protectUserAgent();

export const getImageUrl = (imagePath) => {
  try {
    // console.log('🖼️ getImageUrl called with:', imagePath);
    // console.log('🖼️ WEBSITE_URL:', WEBSITE_URL);
    
    if (!imagePath) {
      // console.log('🖼️ No image path provided, returning empty string');
      return '';
    }
    
    // If the image path is already a full URL, return it as is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      // console.log('🖼️ Image path is already a full URL, returning as is:', imagePath);
      return imagePath;
    }
    
    // Remove leading slash if present
    let cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    
    // Handle version parameters properly
    let versionParam = '';
    if (cleanPath.includes('?v=')) {
      const parts = cleanPath.split('?v=');
      cleanPath = parts[0];
      versionParam = `?v=${parts[1]}`;
      // console.log('🖼️ Extracted version parameter:', versionParam);
    }
    
    // console.log('🖼️ Clean path (without version):', cleanPath);
    
    // Construct the full URL using the backend URL
    const fullUrl = `${WEBSITE_URL}/${cleanPath}${versionParam}`;
    // console.log('🖼️ Constructed full URL:', fullUrl);
    
    return fullUrl;
    
  } catch (error) {
    // Handle userAgent errors specifically
    if (handleUserAgentError(error)) {
      // Return a safe fallback
      return imagePath || '';
    }
    
    // For other errors, log and return fallback
    console.warn('Error in getImageUrl:', error.message);
    return imagePath || '';
  }
}; 